import { memo, useState } from "react";
import { TwTabs as Tabs, Chart, BarChart } from "@ui-component-library";
import { useMetricData } from "../hooks/UseMetricData";
import { usePlusBlockerDialog } from "@components/PlusBlockerDialog/PlusBlockerDialog.context";
import { SubscriptionCoverBanner } from "../components/SubscriptionCovers";

function BarChartWidget() {
  const { openPlusBlockerDialog } = usePlusBlockerDialog();
  const { areaAge, volumeAge, propDfr } = useMetricData();

  const [ageGraphView, setAgeGraphView] = useState("area");

  const ageLabels = [
    "0-10",
    "10-20",
    "20-30",
    "30-40",
    "40-50",
    "50-60",
    "60-70",
    "70-80",
    "80-90",
    "90-100",
    "100+",
  ];

  return (
    <>
      <div className="flex justify-end px-4">
        <div className="bg-cloud-200 rounded-md items-center justify-center">
          <Tabs
            value={ageGraphView}
            tabs={[
              {
                label: "Areal",
                value: "area",
              },
              {
                label: "Volym",
                value: "volume",
              },
            ]}
            onChange={(value) => setAgeGraphView(value)}
          />
        </div>
      </div>
      <div className="flex flex-col space-y-3 px-4 relative">
        {!propDfr ? (
          <SubscriptionCoverBanner
            onClick={() => openPlusBlockerDialog("property-data")}
            label="Åldersfördelning"
          />
        ) : null}
        <div style={!propDfr ? { filter: "blur(9px)" } : {}}>
          {areaAge && ageGraphView == "area" ? (
            <BarChart
              size={{
                height: 330.6667,
                width: "100%",
              }}
              barChart={{
                margin: {
                  top: 5,
                  right: 0,
                  left: -20,
                  bottom: 5,
                },
                data: ageLabels.map((age, index) => ({
                  age: age,
                  area: areaAge[index],
                  unit: "ha",
                })),
              }}
              xAxis={{
                angle: -30,
                tick: { dy: 10 },
                interval: 1,
                dataKey: "age",
              }}
              dataset={[
                {
                  fill: "#7C6ED9",
                  dataKey: "area",
                },
              ]}
              label={{ top: "Ålder:", center: "år" }} //This is the tooltip label

            ></BarChart>
          ) : volumeAge && ageGraphView == "volume" ? (
            <BarChart
              size={{
                height: 330.6667,
                width: "100%",
              }}
              barChart={{
                margin: {
                  top: 5,
                  right: 0,
                  left: -20,
                  bottom: 5,
                },
                data: ageLabels.map((age, index) => ({
                  age: age,
                  volume: volumeAge[index],
                  unit: "m³sk",
                })),

              }}
              xAxis={{
                angle: -45,
                tick: { dy: 10 },
                interval: 1,
                dataKey: "age",
              }}
              dataset={[
                {
                  fill: "#3F8888",
                  dataKey: "volume",
                },
              ]}
              label={{ top: "Ålder:", center: "år" }} //This is the tooltip label
            />
          ) : null}
        </div>
      </div>
    </>
  );
}

export default memo(BarChartWidget);
